import { Card, Fieldset, Heading, Paragraph, Radio } from "@digdir/designsystemet-react";
import "./NavItem.css";
import {
    getRadioOptionsLevel4,
    RADIO_VIEW_VALUES,
    type RadioViewValue,
} from "../../modules/emissions/emissions-chart-utils";

export const NavItemBottomLevel: React.FC<{
    heading: string;
    icon?: React.ReactNode;
    text: string;
    style?: React.CSSProperties;
    selectedView: RadioViewValue;
    onViewChange: (value: RadioViewValue) => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    marketViewAvailable?: boolean;
    accumulatedViewAvailable?: boolean;
    yearlyViewAvailable?: boolean;
}> = ({
    heading,
    icon,
    text,
    style,
    selectedView,
    onViewChange,
    onMouseEnter,
    onMouseLeave,
    marketViewAvailable = true,
    accumulatedViewAvailable = true,
    yearlyViewAvailable = true,
}) => {
    const radioOptions = getRadioOptionsLevel4();
    const filteredOptions = radioOptions.filter((option) => {
        if (!marketViewAvailable && option.value === RADIO_VIEW_VALUES.MARKET) {
            return false;
        }
        if (!accumulatedViewAvailable && option.value === RADIO_VIEW_VALUES.ENOVA_ACCUMULATED) {
            return false;
        }
        if (!yearlyViewAvailable && option.value === RADIO_VIEW_VALUES.ENOVA_YEARLY) {
            return false;
        }
        return true;
    });

    return (
        <Card
            className="nav-item nav-item--bottom"
            data-variant="tinted"
            style={style}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div style={{ display: "flex", justifyContent: "flex-start", gap: "var(--ds-size-3)" }}>
                {icon && <>{icon}</>}

                <div style={{ gap: "var(--ds-size-1)", display: "flex", flexDirection: "column" }}>
                    <Heading level={4} data-size="xs">
                        {heading}
                    </Heading>
                    <Paragraph data-size="sm">{text}</Paragraph>
                </div>
            </div>

            <Fieldset>
                <Fieldset.Legend>Velg visning:</Fieldset.Legend>
                {filteredOptions.map((option) => (
                    <Radio
                        key={option.value}
                        checked={selectedView === option.value}
                        label={option.label}
                        value={option.value}
                        name="vis"
                        onChange={() => onViewChange(option.value)}
                    />
                ))}
            </Fieldset>
        </Card>
    );
};
